import styled from 'styled-components'

import { themeColor } from '@elparking/components'

const RestrictionBadge = styled.div`
    display: inline-flex;
    padding: 0.2em;
    border: 1px solid ${themeColor('red')};
    border-radius: 2px;
`

export default RestrictionBadge
